// TODO: Improve URL link abstraction and management
import type { ComponentType } from 'react';
import { Product } from '@portal/portal-core';
import FlowJoIcon from 'icons/flowjo';
import SeqGeqIcon from 'icons/seqgeq';
import BDRCIcon from 'icons/bdrc';
import InfinicytIcon from 'icons/infinicyt'; // placeholder until we get an svg

import SeqGeqLogo from 'images/product-logos/seqgeq-logo.svg';
import FlowJoLogo from 'images/product-logos/flowjo11-logo-type.svg';
import BDRCLogo from 'images/product-logos/bdrc-logo.svg';
import InfinicytLogo from 'images/product-logos/infinicyt-logo.png';
// need an actual SVG from marketing or come up with a different solution
// import InfinicytLogo from 'images/product-logos/infinicyt.png';

interface ProductLinks {
  home?: string;
  learnMore?: string;
  documentation?: string;
  freeTrial?: string;
  renew?: string;
  eula?: string;
  quote?: string;
}

interface ProductPaths {
  manageDevices: string;
}

interface ProductEot {
  defaultDays: number;
}

interface ProductInfoEntry {
  name: string;
  Icon: ComponentType | null;
  logoSvg: string | null;
  links: ProductLinks;
  paths?: ProductPaths;
  eot?: ProductEot;
}

export const BD_INFORMATICS_MARKETING_URL = 'https://www.flowjo.com';
const INFINICYT_EULA_URL =
  'https://downloads.bdaccessportal.com/Infinicyt/documentation/BD_Infinicyt_Software_EULA_022025.pdf';
export const BD_ACCESS_PORTAL_DOCS = 'https://www.flowjo.com/docs/bdaccessportal/home';

const { NAMES, NAMES_UI_TABS, PRODUCT_MARKETING_NAMES } = Product;

export const FLOWJO_DOCS_URL = 'https://flowjo.com/docs/flowjo11';

export const PRODUCT_INFO: Record<string, ProductInfoEntry> = {
  [NAMES_UI_TABS.flowJo]: {
    name: PRODUCT_MARKETING_NAMES[NAMES_UI_TABS.flowJo],
    Icon: FlowJoIcon,
    logoSvg: FlowJoLogo,
    links: {
      learnMore: `${BD_INFORMATICS_MARKETING_URL}/solutions/flowjo`,
      documentation: FLOWJO_DOCS_URL,
      freeTrial: `./product-trial?productName=${NAMES.flowJo}`,
      // renew: 'https://dev-www-flowjohub.eyecue.io/renew',
      eula: `${BD_INFORMATICS_MARKETING_URL}/solutions/flowjo/eula`,
      quote: `${BD_INFORMATICS_MARKETING_URL}/solutions/flowjo/request-quote`,
    },
    paths: {
      manageDevices: `/manage-devices?productName=${NAMES_UI_TABS.flowJo}`,
    },
    eot: {
      defaultDays: 14,
    },
  },
  [NAMES_UI_TABS.seqGeq]: {
    name: PRODUCT_MARKETING_NAMES[NAMES_UI_TABS.seqGeq],
    Icon: SeqGeqIcon,
    logoSvg: SeqGeqLogo,
    links: {
      learnMore: `${BD_INFORMATICS_MARKETING_URL}/solutions/seqgeq`,
      documentation: 'http://docs.flowjo.com/seqgeq',
      renew: 'https://dev-www-flowjohub.eyecue.io/renew',
      eula: `${BD_INFORMATICS_MARKETING_URL}/solutions/seqgeq/eula`,
      quote: `${BD_INFORMATICS_MARKETING_URL}/solutions/seqgeq/request-quote`,
    },
    paths: {
      manageDevices: `/manage-devices?productName=${NAMES_UI_TABS.seqGeq}`,
    },
  },
  [NAMES_UI_TABS.bdrc]: {
    name: PRODUCT_MARKETING_NAMES[NAMES_UI_TABS.bdrc],
    Icon: BDRCIcon,
    logoSvg: BDRCLogo,
    links: {
      home: 'https://bdresearchcloud.com',
      learnMore: `${BD_INFORMATICS_MARKETING_URL}/solutions/bd-research-cloud`,
      eula: `${BD_INFORMATICS_MARKETING_URL}/solutions/bd-research-cloud/eula`,
      quote: `${BD_INFORMATICS_MARKETING_URL}/solutions/seqgeq/request-quote`,
    },
  },
  [NAMES_UI_TABS.infinicytRuo]: {
    name: PRODUCT_MARKETING_NAMES[NAMES_UI_TABS.infinicytRuo],
    Icon: InfinicytIcon,
    logoSvg: InfinicytLogo,
    links: {
      learnMore: 'https://www.bdbiosciences.com/infinicyt',
      documentation: BD_ACCESS_PORTAL_DOCS,
      freeTrial: 'https://www.bdbiosciences.com/infinicyt',
      eula: INFINICYT_EULA_URL,
      quote: 'https://www.bdbiosciences.com/infinicyt',
    },
    paths: {
      manageDevices: `/manage-devices?productName=${NAMES_UI_TABS.infinicytRuo}`,
    },
    eot: {
      defaultDays: 360,
    },
  },
  [NAMES_UI_TABS.infinicytIvd]: {
    name: PRODUCT_MARKETING_NAMES[NAMES_UI_TABS.infinicytIvd],
    Icon: InfinicytIcon,
    logoSvg: InfinicytLogo,
    links: {
      learnMore: 'https://www.bdbiosciences.com/infinicyt',
      documentation: BD_ACCESS_PORTAL_DOCS,
      freeTrial: 'https://www.bdbiosciences.com/infinicyt',
      eula: INFINICYT_EULA_URL,
      quote: 'https://www.bdbiosciences.com/infinicyt',
    },
    paths: {
      manageDevices: `/manage-devices?productName=${NAMES_UI_TABS.infinicytIvd}`,
    },
    eot: {
      defaultDays: 360,
    },
  },
  [NAMES_UI_TABS.infinicytUsIvd]: {
    name: PRODUCT_MARKETING_NAMES[NAMES_UI_TABS.infinicytUsIvd],
    Icon: InfinicytIcon,
    logoSvg: InfinicytLogo,
    links: {
      learnMore: 'https://www.bdbiosciences.com/infinicyt',
      documentation: BD_ACCESS_PORTAL_DOCS,
      freeTrial: 'https://www.bdbiosciences.com/infinicyt',
      eula: INFINICYT_EULA_URL,
      quote: 'https://www.bdbiosciences.com/infinicyt',
    },
    paths: {
      manageDevices: `/manage-devices?productName=${NAMES_UI_TABS.infinicytUsIvd}`,
    },
    eot: {
      defaultDays: 360,
    },
  },
  [NAMES_UI_TABS.infinicytEa]: {
    name: PRODUCT_MARKETING_NAMES[NAMES_UI_TABS.infinicytEa],
    Icon: InfinicytIcon,
    logoSvg: InfinicytLogo,
    links: {
      learnMore: 'https://www.bdbiosciences.com/infinicyt',
      documentation: BD_ACCESS_PORTAL_DOCS,
      freeTrial: 'https://www.bdbiosciences.com/infinicyt',
      eula: INFINICYT_EULA_URL,
      quote: 'https://www.bdbiosciences.com/infinicyt',
    },
    paths: {
      manageDevices: `/manage-devices?productName=${NAMES_UI_TABS.infinicytEa}`,
    },
    eot: {
      defaultDays: 360,
    },
  },
  [NAMES_UI_TABS.infinicytIuo]: {
    name: PRODUCT_MARKETING_NAMES[NAMES_UI_TABS.infinicytIuo],
    Icon: InfinicytIcon,
    logoSvg: InfinicytLogo,
    links: {
      learnMore: 'https://www.bdbiosciences.com/infinicyt',
      documentation: BD_ACCESS_PORTAL_DOCS,
      freeTrial: 'https://www.bdbiosciences.com/infinicyt',
      eula: INFINICYT_EULA_URL,
      quote: 'https://www.bdbiosciences.com/infinicyt',
    },
    paths: {
      manageDevices: `/manage-devices?productName=${NAMES_UI_TABS.infinicytIuo}`,
    },
    eot: {
      defaultDays: 360,
    },
  },
  [NAMES_UI_TABS.facsWorkflowManager]: {
    name: PRODUCT_MARKETING_NAMES[NAMES_UI_TABS.facsWorkflowManager],
    Icon: null,
    logoSvg: null,
    links: {
      learnMore: 'https://www.bdbiosciences.com/en-us/products/software/connectivity-software',
      documentation: 'https://www.bdbiosciences.com/en-us/products/software/connectivity-software',
      freeTrial: 'https://www.bdbiosciences.com/en-us/products/software/connectivity-software',
      eula: 'https://www.bdbiosciences.com/en-us/products/software/connectivity-software',
      quote: 'https://www.bdbiosciences.com/en-us/products/software/connectivity-software',
    },
    paths: {
      manageDevices: `/manage-devices?productName=${NAMES_UI_TABS.facsWorkflowManager}`,
    },
    eot: {
      defaultDays: 360,
    },
  },
};

export const PRODUCT_INFO_CHINA: Record<string, ProductInfoEntry> = {
  [NAMES_UI_TABS.flowJo]: {
    name: 'FlowJo',
    Icon: FlowJoIcon,
    logoSvg: FlowJoLogo,
    links: {
      learnMore: '/solutions/flowjo',
      documentation: FLOWJO_DOCS_URL,
      freeTrial: `${BD_INFORMATICS_MARKETING_URL}/solutions/flowjo/free-trial`,
      renew: 'https://dev-www-flowjohub.eyecue.io/renew',
      eula: `${BD_INFORMATICS_MARKETING_URL}https://www.flowjo.com/solutions/flowjo/eula`,
      quote: `${BD_INFORMATICS_MARKETING_URL}/solutions/flowjo/request-quote`,
    },
    paths: {
      manageDevices: `/manage-devices?productName=${NAMES_UI_TABS.flowJo}`,
    },
  },
  [NAMES_UI_TABS.seqGeq]: {
    name: 'SeqGeq',
    Icon: SeqGeqIcon,
    logoSvg: SeqGeqLogo,
    links: {
      learnMore: `${BD_INFORMATICS_MARKETING_URL}/solutions/seqgeq`,
      documentation: 'http://docs.flowjo.com/seqgeq',
      renew: 'https://dev-www-flowjohub.eyecue.io/renew',
      eula: `${BD_INFORMATICS_MARKETING_URL}/solutions/seqgeq/eula`,
      quote: `${BD_INFORMATICS_MARKETING_URL}/solutions/seqgeq/request-quote`,
    },
    paths: {
      manageDevices: `/manage-devices?productName=${NAMES_UI_TABS.seqGeq}`,
    },
  },
};

export const productInfo = (productName: string): ProductInfoEntry | undefined =>
  PRODUCT_INFO[productName];

export const productInfoChina = (productName: string): ProductInfoEntry | undefined =>
  PRODUCT_INFO_CHINA[productName];
